export default __webpack_public_path__ + "static/media/Snd5.da2850a8.mp3";